import React from "react";

/**
 * @param {object} props
 * @param {string} props.manualMatchingHelpText
 * @returns {React.JSX.Element}
 */
const ManualMatchingHelpText = ({ manualMatchingHelpText }) => (
    <div className="-padding-left--30 -padding-top--5">
        <p className="-type--small">{manualMatchingHelpText}</p>
    </div>
);

export default ManualMatchingHelpText;
